import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=13d254ab&scoped=true&"
import script from "./PropertyValue.vue?vue&type=script&lang=js&"
export * from "./PropertyValue.vue?vue&type=script&lang=js&"
import style0 from "./PropertyValue.vue?vue&type=style&index=0&id=13d254ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d254ab",
  null
  
)

export default component.exports